let filters = {
	reviewee: {name: 'reviewee', 'nickname': 'Reviewee', type: 'multi', options: {},selections: {}, size: 3},
	role: {name: 'role', 'nickname': 'Role', type: 'multi', options: {},selections: {}, size: 3},
	last_reviewed: {name: 'last_reviewed', 'nickname': 'Reviewed During', type: 'date_range', options: {},selections: {}, size: 3},
	gc: {name: 'gc', 'nickname': 'Group Companies', type: 'multi', options: {},selections: {}, size: 3},
	lc_month: {name: 'lc_month', 'nickname': 'Review Month', type: 'multi', options: {},selections: {}, size: 3},
	reviewed: {name: 'reviewed', 'nickname': 'Review Count', type: 'multi', options: {},selections: {}, size: 3}
}

module.exports = filters